/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.settings.integration.logs.modals.view.controllers', [
  'ui.bootstrap',
  'acme.common.directive.modal',
  'acme.common.directive.ribon',
  'acme.common.service.api',
  'acme.common.service.userPreferences'
])

.controller('SettingsIntegrationLogsModalsViewController', [
  '$scope', 
  '$filter',
  '$uibModalInstance', 
  'ApiService',
  'UserPreferencesService',
  'formObjectData',
  'itemData', 
  function(
    $scope, 
    $filter,
    $uibModalInstance, 
    ApiService, 
    UserPreferencesService,
    formObjectData,
    itemData) {

    $scope.settingsIntegrationLogsModalsView = {

      model: {},
      input: {
        payload: {}
      },
      output: {
        response: {}
      },

      formObject: {},

      title: '',

      hasError: false,

      loading: true,

      dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

      init: function() {
        this.title = 'Loading';
        this.formObject = formObjectData;
        ApiService.sfdc.logs.get(itemData.id).then(this.success.init, this.error.init);
      },

      processItem: function() {
        var dateTime = new Date(this.model.createdOn),
            startTime = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), dateTime.getHours(), dateTime.getMinutes());

        this.title = 'Searched ID: ' + this.formObject.logId + ' | ' +  $filter('date')(startTime, this.dateTimeFormat);

        this.input.payload = this.model.payload;
        this.output.response = this.model.response;
      },

      done: function() {
        $uibModalInstance.close('success');
      },

      success: {
        init: function(res) {
          var self = $scope.settingsIntegrationLogsModalsView;
          self.model = res.data.payload; 
          self.model.messageIdDateParsed = itemData.messageIdDateParsed;
          self.processItem();
          self.hasError = false;
          self.loading = false;
        }
      },

      error: {
        init: function(res) {
          var self = $scope.settingsIntegrationLogsModalsView;
          self.title = 'Error';
          self.hasError = true;
          self.loading = false;
        }
      }

    };

    $scope.settingsIntegrationLogsModalsView.init();

}]);